import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AppGlobals } from '@app/app.global';
import { AuthService, CourseRequest, SharedService, User } from '@app/core';
import { CourseService as GlobalCourseService } from '@app/services';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: false,
})
export class NavbarComponent implements AfterViewInit, OnInit {
  loggedinUser: User;
  page = 1;
  isMoreRequestLoading = false;
  requests: CourseRequest[] = [];
  requestCount = 0;

  constructor(
    private authService: AuthService,
    public appGlobals: AppGlobals,
    private globalCourseService: GlobalCourseService,
    private sharedService: SharedService
  ) {
    this.loggedinUser = this.authService.user;
  }

  ngAfterViewInit(): void {
    this.globalCourseService.requestCount$.subscribe(count => {
      this.requestCount = count;
    });
  }

  ngOnInit() {
    this.getRequests();
    if (!this.loggedinUser) {
      this.logout();
    }

    // if (this.loggedinUser.configuredLanguage &&
    //   this.appGlobals.languages.map(lang => lang.id).includes(this.loggedinUser.configuredLanguage.toLowerCase())) {
    //   this.sharedService.changeLanguage(this.loggedinUser.configuredLanguage.toLowerCase());
    // }
  }

  get isImpersonated() {
    return this.authService.isImpersonated;
  }

  originate() {
    this.authService.originate().subscribe(
      (res: any) => {
        window.location.reload();
        this.sharedService.successAlert('impersonation revoked successfully!');
      },
      (error: any) => {
        this.sharedService.errorAlert(error);
      }
    );
  }

  toggleSideBar() {
    this.sharedService.sideBarToggle.emit();
  }

  logout() {
    this.authService.logout();
  }

  getRequests() {
    const params: any = { page: this.page };
    if (this.loggedinUser.isPlayer) {
      this.globalCourseService.getInvitations(params, this.isMoreRequestLoading).subscribe(
        (res: any) => {
          if (this.isMoreRequestLoading) {
            this.requests = [...this.requests, ...res.results];
          } else {
            this.requests = res.results;
          }
          this.requestCount = res.count;
          this.globalCourseService.updateRequestCount(res.count);
          this.isMoreRequestLoading = false;
        },
        (error: any) => {
          this.isMoreRequestLoading = false;
          this.sharedService.errorAlert(error);
        }
      );
    } else {
      this.globalCourseService.getRequests(params, this.isMoreRequestLoading).subscribe(
        (res: any) => {
          if (this.isMoreRequestLoading) {
            this.requests = [...this.requests, ...res.results];
          } else {
            this.requests = res.results;
          }
          this.requestCount = res.count;
          this.isMoreRequestLoading = false;
        },
        (error: any) => {
          this.isMoreRequestLoading = false;
          this.sharedService.errorAlert(error);
        }
      );
    }
  }
}
